import { useAuthHeaders } from "./useAuthHeaders"
import { useSessionStore } from "../stores/sessionStore";
import { useCallback, useEffect } from "react";

export const useSessionStateSync = () => {
  const { getAuthHeader } = useAuthHeaders();
  const update = useCallback(async () => {
    const headers = await getAuthHeader();
    if (!headers) return;
    const data = await fetch('/api/sessions/state', { headers })
      .then(res => res.json())
      .then(data => {
        if (!data.ok) return {};
        return data.data;
      });
    useSessionStore.getState().updateStore(data?.total || [], data?.map || {});
  }, [getAuthHeader]);
  useEffect(() => {
    update();
    const id = setInterval(async () => {
      await update();
    }, 5000);
    return () => clearInterval(id);
  }, [update]);
}